import { getGoBoardCoordinateKey } from "@/utils/get-go-board-coordinate-key";
const getMokaGameStateWithoutStones = (gameState, removedStoneCoordinates) => {
  const boardSize = gameState.board.length;
  const removedStoneCoordinateKeys = new Set(removedStoneCoordinates.map(coordinate => getGoBoardCoordinateKey(coordinate, boardSize)));
  return {
    ...gameState,
    board: gameState.board.map(boardRow => boardRow.map(stone => stone && removedStoneCoordinateKeys.has(getGoBoardCoordinateKey(stone, boardSize)) ? null : stone))
  };
};
export { getMokaGameStateWithoutStones };